import React, { AnchorHTMLAttributes } from 'react';

import { StyledPillButton, PillButtonSize, PillButtonVariant } from './styles';

interface PillButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: PillButtonVariant;
  size?: PillButtonSize;
  fullWidth?: boolean;
  as?: React.ElementType;
}

const PillButton: React.FC<PillButtonProps> = ({
  variant = 'solid',
  size = 'md',
  fullWidth = false,
  children,
  ...rest
}) => {
  return (
    <StyledPillButton
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      {...rest}
    >
      {children}
    </StyledPillButton>
  );
};

export { PillButton };
